import { connect } from "react-redux";
import moment from "moment";
import { parseAsLocalDate } from "../../utils";
import { Fade, JackInTheBox } from "react-awesome-reveal";

const BottomSection = ({ eventDate }) => {
  return (
    <Fade
      duration={1000} // Animation duration
      triggerOnce
    >
      <section className="celebration-section">
        <JackInTheBox duration={1000} triggerOnce="true">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="white"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            className="icon"
          >
            <path d="M19 14c1.49-1.46 3-3.21 3-5.5A5.5 5.5 0 0 0 16.5 3c-1.76 0-3 .5-4.5 2-1.5-1.5-2.74-2-4.5-2A5.5 5.5 0 0 0 2 8.5c0 2.3 1.5 4.05 3 5.5l7 7Z"></path>
          </svg>
        </JackInTheBox>
        <p className="title">Looking forward to celebrating with you!</p>
        <p className="subtitle">
          Save the date:{" "}
          {moment(parseAsLocalDate(eventDate)).format("MMMM DD, YYYY")}
        </p>
      </section>
    </Fade>
  );
};

const mapStateToProps = (state) => {
  return {
    eventDate: state.inviteDetails.invite?.eventDate,
  };
};
export default connect(mapStateToProps)(BottomSection);
